module.exports = __webpack_public_path__ + "img/9788958073086.17da98e1.jpg";